import { MsalGuardConfiguration } from "@azure/msal-angular";
import { InteractionType } from "@azure/msal-browser";
import { NO_ACCESS_ROUTE } from "@/core/services/app-access.service";
import { environment } from "environments/environment";

export default function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: [...environment.apiConfig.scopes],
        },
        /**
         * Dónde cae la navegación cuando `MsalGuard` no pudo autenticar.
         *
         * ⚠️ Antes apuntaba a `/login-failed`, una ruta que NO existe en `appRoutes`: el comodín
         * `**` la mandaba a `/notfound` y el usuario terminaba en un "404 — la página no existe"
         * que no tiene nada que ver con lo que pasó y desde el que no se puede hacer nada.
         *
         * `/no-access` es la pantalla que sí corresponde: dice con qué cuenta se entró y ofrece
         * iniciar sesión, cambiar de cuenta o salir. Ver `NoAccess` y `appAccessGuard`.
         */
        loginFailedRoute: NO_ACCESS_ROUTE,
    };
}
